export const LIFTS_HIKING = [
    { sismediaResortId: '1', sismediaLiftId: '600' },
    { sismediaResortId: '1', sismediaLiftId: '15' },
    { sismediaResortId: '1', sismediaLiftId: '16' },
    { sismediaResortId: '1', sismediaLiftId: '17' },
    { sismediaResortId: '1', sismediaLiftId: '18' },
    { sismediaResortId: '1', sismediaLiftId: '2' },
    { sismediaResortId: '1', sismediaLiftId: '3' },
    { sismediaResortId: '1', sismediaLiftId: '4' },
    { sismediaResortId: '1', sismediaLiftId: '5' },
    { sismediaResortId: '1', sismediaLiftId: '7' },
    { sismediaResortId: '1', sismediaLiftId: '8' },
    { sismediaResortId: '1', sismediaLiftId: '9' },
    { sismediaResortId: '1', sismediaLiftId: '10' },
    { sismediaResortId: '1', sismediaLiftId: '12' },
    { sismediaResortId: '1', sismediaLiftId: '1004' },
    { sismediaResortId: '2', sismediaLiftId: '5' },
    { sismediaResortId: '2', sismediaLiftId: '6' },
    { sismediaResortId: '2', sismediaLiftId: '7' },
    { sismediaResortId: '2', sismediaLiftId: '10' },
    { sismediaResortId: '2', sismediaLiftId: '11' },
    { sismediaResortId: '2', sismediaLiftId: '1' },
    { sismediaResortId: '2', sismediaLiftId: '3' },
    { sismediaResortId: '2', sismediaLiftId: '4' },
    { sismediaResortId: '3', sismediaLiftId: '3' },
    { sismediaResortId: '3', sismediaLiftId: '4' },
    { sismediaResortId: '3', sismediaLiftId: '5' },
    { sismediaResortId: '3', sismediaLiftId: '16' },
    { sismediaResortId: '3', sismediaLiftId: '15' },
    { sismediaResortId: '3', sismediaLiftId: '19' },
    { sismediaResortId: '3', sismediaLiftId: '20' },

];

export const LIFTS_TOBOGGANING = [
    { sismediaResortId: '1', sismediaLiftId: '600' },
    { sismediaResortId: '1', sismediaLiftId: '15' },
    { sismediaResortId: '1', sismediaLiftId: '16' },
    { sismediaResortId: '1', sismediaLiftId: '17' },
    { sismediaResortId: '1', sismediaLiftId: '2' },
    { sismediaResortId: '1', sismediaLiftId: '3' },
    { sismediaResortId: '1', sismediaLiftId: '4' },
    { sismediaResortId: '1', sismediaLiftId: '5' },
    { sismediaResortId: '1', sismediaLiftId: '7' },
    { sismediaResortId: '1', sismediaLiftId: '8' },
    { sismediaResortId: '1', sismediaLiftId: '9' },
    { sismediaResortId: '1', sismediaLiftId: '10' },
    { sismediaResortId: '1', sismediaLiftId: '12' },
    { sismediaResortId: '1', sismediaLiftId: '1004' },
    { sismediaResortId: '2', sismediaLiftId: '5' },
    { sismediaResortId: '2', sismediaLiftId: '6' },
    { sismediaResortId: '2', sismediaLiftId: '7' },
    { sismediaResortId: '2', sismediaLiftId: '10' },
    { sismediaResortId: '2', sismediaLiftId: '11' },
    { sismediaResortId: '2', sismediaLiftId: '1' },
    { sismediaResortId: '2', sismediaLiftId: '3' },
    { sismediaResortId: '2', sismediaLiftId: '4' },
    { sismediaResortId: '3', sismediaLiftId: '3' },
    { sismediaResortId: '3', sismediaLiftId: '4' },
    { sismediaResortId: '3', sismediaLiftId: '5' },
    { sismediaResortId: '3', sismediaLiftId: '15' },
    { sismediaResortId: '3', sismediaLiftId: '16' },
    { sismediaResortId: '3', sismediaLiftId: '19' },
    { sismediaResortId: '3', sismediaLiftId: '20' },
];

export const LIFTS_NOT_SKIING = [
    { sismediaResortId: '3', sismediaLiftId: '19' },
    { sismediaResortId: '3', sismediaLiftId: '20' },
];

export const TRACKS_TOBOGGANING = [
    { sismediaResortId: '3', sismediaTrackId: '25' },
    { sismediaResortId: '3', sismediaTrackId: '105' },
];

export const TRACKS_HIKING = [
    { sismediaResortId: '3', sismediaTrackId: '25' },
    { sismediaResortId: '3', sismediaTrackId: '105' },
];

export const POIS_HIKING = [
    { sismediaResortId: 1, sismediaPoiId: 1 },
    { sismediaResortId: 1, sismediaPoiId: 10 },
    { sismediaResortId: 1, sismediaPoiId: 2 },
    { sismediaResortId: 1, sismediaPoiId: 3 },
    { sismediaResortId: 1, sismediaPoiId: 13 },
    { sismediaResortId: 1, sismediaPoiId: 12 },
    { sismediaResortId: 2, sismediaPoiId: 2 },
    { sismediaResortId: 2, sismediaPoiId: 3 },
    { sismediaResortId: 2, sismediaPoiId: 5 },
    { sismediaResortId: 2, sismediaPoiId: 4 },
    { sismediaResortId: 3, sismediaPoiId: 14 },
    { sismediaResortId: 3, sismediaPoiId: 7 },
    { sismediaResortId: 3, sismediaPoiId: 6 },
    { sismediaResortId: 3, sismediaPoiId: 5 },
    { sismediaResortId: 3, sismediaPoiId: 2 },
    { sismediaResortId: 3, sismediaPoiId: 3 },
    { sismediaResortId: 3, sismediaPoiId: 22 },
    { sismediaResortId: 3, sismediaPoiId: 12 },
    { sismediaResortId: 3, sismediaPoiId: 14 },
    { sismediaResortId: 3, sismediaPoiId: 11 },
    { sismediaResortId: 3, sismediaPoiId: 10 },
    { sismediaResortId: 3, sismediaPoiId: 9 },
    { sismediaResortId: 3, sismediaPoiId: 8 },
    { sismediaResortId: 3, sismediaPoiId: 13 },
    { sismediaResortId: 3, sismediaPoiId: 21 },
    { sismediaResortId: 3, sismediaPoiId: 4 },

    { sismediaResortId: 3, sismediaPoiId: 34 },
    { sismediaResortId: 3, sismediaPoiId: 35 },
    { sismediaResortId: 3, sismediaPoiId: 36 },
    { sismediaResortId: 3, sismediaPoiId: 37 },
];

export const POIS_TOBOGGANING = [
    { sismediaResortId: 1, sismediaPoiId: 1 },
    { sismediaResortId: 1, sismediaPoiId: 10 },
    { sismediaResortId: 1, sismediaPoiId: 2 },
    { sismediaResortId: 1, sismediaPoiId: 3 },
    { sismediaResortId: 1, sismediaPoiId: 13 },
    { sismediaResortId: 1, sismediaPoiId: 12 },
    { sismediaResortId: 2, sismediaPoiId: 2 },
    { sismediaResortId: 2, sismediaPoiId: 3 },
    { sismediaResortId: 2, sismediaPoiId: 5 },
    { sismediaResortId: 2, sismediaPoiId: 4 },
    { sismediaResortId: 3, sismediaPoiId: 7 },
    { sismediaResortId: 3, sismediaPoiId: 6 },
    { sismediaResortId: 3, sismediaPoiId: 5 },
    { sismediaResortId: 3, sismediaPoiId: 2 },
    { sismediaResortId: 3, sismediaPoiId: 3 },
    { sismediaResortId: 3, sismediaPoiId: 22 },
    { sismediaResortId: 3, sismediaPoiId: 12 },
    { sismediaResortId: 3, sismediaPoiId: 14 },
    { sismediaResortId: 3, sismediaPoiId: 11 },
    { sismediaResortId: 3, sismediaPoiId: 10 },
    { sismediaResortId: 3, sismediaPoiId: 9 },
    { sismediaResortId: 3, sismediaPoiId: 8 },
    { sismediaResortId: 3, sismediaPoiId: 13 },
    { sismediaResortId: 3, sismediaPoiId: 21 },
    { sismediaResortId: 3, sismediaPoiId: 4 },

    { sismediaResortId: 3, sismediaPoiId: 34 },
    { sismediaResortId: 3, sismediaPoiId: 35 },
    { sismediaResortId: 3, sismediaPoiId: 36 },
    { sismediaResortId: 3, sismediaPoiId: 37 },
];

export const POIS_NOT_SKIING = [
    { sismediaResortId: 3, sismediaPoiId: 14 },
    { sismediaResortId: 3, sismediaPoiId: 34 },
    { sismediaResortId: 3, sismediaPoiId: 35 },
    { sismediaResortId: 3, sismediaPoiId: 36 },
    { sismediaResortId: 3, sismediaPoiId: 37 },
];

export const RESTAURANTS_HIKING = [
    'resort_1_restaurant_1',
    'resort_1_restaurant_2',
    'resort_1_restaurant_5',
    'resort_1_restaurant_7',
    'resort_1_restaurant_8',
    'resort_1_restaurant_9',
    'resort_1_restaurant_10',
    // 'resort_1_restaurant_11',
    'resort_1_restaurant_12',
    'resort_1_restaurant_14',
    // 'resort_1_restaurant_15',
    // 'resort_1_restaurant_16',
    'resort_1_restaurant_17',
    'resort_1_restaurant_18',
    'resort_1_restaurant_33',
    // 'resort_1_restaurant_19',
    // 'resort_1_restaurant_20',
    // 'resort_1_restaurant_21', // ok sleg
    'resort_1_restaurant_22',
    'resort_1_restaurant_23',
    'resort_1_restaurant_1000',
    // 'resort_1_restaurant_1002',
    // 'resort_1_restaurant_1004',   // ok sleg
    'resort_1_restaurant_1005',
    'resort_1_restaurant_1007',
    'resort_1_restaurant_1008',
    // 'resort_1_restaurant_1009',
    // 'resort_1_restaurant_1010',
    // 'resort_1_restaurant_1011',   // ok sleg
    'resort_2_restaurant_1',
    // 'resort_2_restaurant_3',
    'resort_2_restaurant_4',
    // 'resort_2_restaurant_5',
    // 'resort_2_restaurant_6',
    'resort_2_restaurant_7',
    // 'resort_2_restaurant_8',
    // 'resort_2_restaurant_9',
    'resort_2_restaurant_10',
    'resort_3_restaurant_2',
    'resort_3_restaurant_3',
    'resort_3_restaurant_4',
    'resort_3_restaurant_5',
    'resort_3_restaurant_11',
    'resort_3_restaurant_12',
    'resort_3_restaurant_14',
    'resort_3_restaurant_26',
    'resort_3_restaurant_28',
    // 'resort_3_restaurant_29',
    // 'resort_3_restaurant_25',
    // 'resort_3_restaurant_30',
    // 'resort_3_restaurant_1001',
    'resort_3_restaurant_1008',
];

export const RESTAURANTS_TOBOGGANING = [
    'resort_1_restaurant_1',
    'resort_1_restaurant_2',
    'resort_1_restaurant_5',
    'resort_1_restaurant_7',
    'resort_1_restaurant_8',
    'resort_1_restaurant_9',
    'resort_1_restaurant_10',
    // 'resort_1_restaurant_11',
    'resort_1_restaurant_12',
    'resort_1_restaurant_14',
    // 'resort_1_restaurant_15',
    // 'resort_1_restaurant_16',
    'resort_1_restaurant_17',
    'resort_1_restaurant_18',
    'resort_1_restaurant_33',
    // 'resort_1_restaurant_19',
    // 'resort_1_restaurant_20',
    'resort_1_restaurant_21',
    'resort_1_restaurant_22',
    'resort_1_restaurant_23',
    'resort_1_restaurant_1000',
    // 'resort_1_restaurant_1002',
    'resort_1_restaurant_1004',
    'resort_1_restaurant_1005',
    'resort_1_restaurant_1007',
    'resort_1_restaurant_1008',
    // 'resort_1_restaurant_1009',
    // 'resort_1_restaurant_1010',
    'resort_1_restaurant_1011',
    'resort_2_restaurant_1',
    // 'resort_2_restaurant_3',
    'resort_2_restaurant_4',
    // 'resort_2_restaurant_5',
    // 'resort_2_restaurant_6',
    'resort_2_restaurant_7',
    // 'resort_2_restaurant_8',
    // 'resort_2_restaurant_9',
    'resort_2_restaurant_10',
    'resort_3_restaurant_2',
    'resort_3_restaurant_3',
    'resort_3_restaurant_4',
    'resort_3_restaurant_5',
    'resort_3_restaurant_11',
    'resort_3_restaurant_12',
    'resort_3_restaurant_14',
    'resort_3_restaurant_26',
    'resort_3_restaurant_28',
    // 'resort_3_restaurant_29',
    // 'resort_3_restaurant_25',
    // 'resort_3_restaurant_30',
    // 'resort_3_restaurant_1001',
    'resort_3_restaurant_1008',
];

export const RESTAURANTS_NOT_SKIING = [
    'resort_3_restaurant_3',
    'resort_3_restaurant_11',
    'resort_3_restaurant_12',
];

export const WEBCAMS_NOT_SKIING = [
    'WEBCAM_BUSSALP',
];
